import utagLinkGeneric from './utagLinkGeneric';

function trackReplacementParts ({
	eventAction, eventCategory = 'PDP', eventLabel = '', nonInteraction = 0
}) {

	utagLinkGeneric({
		eventCategory,
		eventAction,
		eventLabel,
		nonInteraction
	});

}

export default trackReplacementParts;
